import { useLayoutEffect } from "react"
import { useRouterState } from "@tanstack/react-router"

// The app scrolls inside the shell's <main>, not the window, so the router's
// built-in scrollRestoration (window-only by default) never resets it between
// pages — without this, navigating e.g. explore → guide keeps the previous
// page's scroll offset.
export function ScrollToTop({ scrollRef }: { scrollRef: React.RefObject<HTMLElement | null> }) {
  // Use the *resolved* location, not the pending one. `location` flips the
  // instant a navigation starts — while the destination's data/code is still
  // loading and the previous page is still on screen — so resetting scroll then
  // visibly yanks the old page (e.g. the dashboard) to the top before the new
  // page appears. `resolvedLocation` only changes once the new page is actually
  // committed, so the scroll reset happens on the page you're landing on.
  const pathname = useRouterState({
    select: (s) => s.resolvedLocation?.pathname ?? s.location.pathname,
  })

  useLayoutEffect(() => {
    scrollRef.current?.scrollTo(0, 0)
  }, [pathname, scrollRef])

  return null
}
